import '../App.css';
import React, { useEffect, useRef, useState } from 'react';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import GetSites from '../components/api/GetSites';
import GetAuthKey from '../components/api/GetAuthKey';
import LoginCookieAuth from '../components/api/LoginCookieAuth';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Divider, Grid, InputAdornment } from '@mui/material';
import { AccountCircle } from '@mui/icons-material';
import LockIcon from '@mui/icons-material/Lock';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import backgroundImage from '../img/homepageFoto.avif'
import InfLoader from '../components/infLoad';

function Login() {
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [credentialsInvalid, setCredentialsInvalid] = useState(false);
  const [reLoginDone, setReLoginDone] = useState(false);
  const [accessDenied, setAccessDenied] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [proccesing, setProccesing] = useState(false)
  const navigate = useNavigate();
  const usernameRef = useRef(null);
  

  useEffect(() => {
    // Focus username field
    if (reLoginDone) usernameRef.current.focus();
    const key = Cookies.get('skyarc-auth-8080');
    
    // Check if user has cookie
    if (!key) {
      setReLoginDone(true);
      return;
    } else {
      LoginCookieAuth(key).then((response) => {
        if (response) {
          setReLoginDone(true);
          navigate('/projects');
        } else {
          Cookies.remove('skyarc-auth-8080');
          setReLoginDone(true);
          return;
        }
      });
    }
  }, [navigate, reLoginDone]);

  const handleLogin = async (event) => {
    setProccesing(true)
    // Prevent page reloading when login button is pressed
    event.preventDefault();
    try {
      await GetAuthKey(userName, password).then((authResponse) => {
        if (authResponse.status === 200) {
          GetSites(authResponse.data.token).then((response) => {
            const responseData = response.data;
            if(responseData === undefined) {
              setProccesing(false)
              setAccessDenied(true);
            } else {
              const responseVal = responseData['rows'];
              if (responseVal.length === 0) {
                setProccesing(false)
                setAccessDenied(true);
              } else {
                setProccesing(false)
                //only set cookie after confirming dashboard access
                Cookies.set('skyarc-auth-8080', authResponse.data.token);
                navigate('/projects');
              }
            }
          });
        }
      });
    } catch (error) {
      setProccesing(false)
      setCredentialsInvalid(true);
    }
  };
 
  return (
    <>
      {reLoginDone ? (
        <Grid container gap={0} sx={{height:'100%', overflowX:'hidden'}}>
          <Grid item xl={6} lg={6} md={12} sm={12} xs={12} sx={{backgroundColor:'#f9fafc', height:'100%', display:'flex', alignItems:'center'}}>
            <Box sx={{width:'100%', display:'flex', justifyContent:'center', flexDirection:'column', alignItems:'center'}}>
              <Box sx={{mb:{xl:'30px', lg:'30px', md:'30px', sm:'20px', xs:'20px'}, display:'flex', flexDirection:'column', alignItems:'center'}}>
                <Box sx={{display:'flex', alignItems:'center'}}>
                  <Box component='img' src={process.env.PUBLIC_URL + '/inf-logo.svg'} alt='logo' sx={{width:{xl:'85px', lg:'85px', md:'85px', sm:'75px', xs:'65px'}, height:{xl:'75px', lg:'75px', md:'75px', sm:'65px', xs:'55px'}, pointerEvents:'none'}}/>
                  <Box component='img' src={process.env.PUBLIC_URL + '/inf-logo-text.svg'} alt='logo' sx={{height:{xl:'75px', lg:'75px', md:'75px', sm:'65px', xs:'55px'}, marginLeft:'15px', pointerEvents:'none'}}/>
                </Box>
                <Divider sx={{mt: "25px", height: "3px", width:'150px', border: "none", borderRadius: "5px", background: "linear-gradient(90deg, rgba(50,235,149,1) 0%, rgba(105,238,175,1) 50%, rgba(225,248,239,1) 100%)"}}/>
              </Box>
              <Box sx={{width:{xl:'500px', lg:'500px', md:'500px', sm:'400px', xs:'300px'}, height:'300px', backgroundColor:'#ffffff', borderRadius:'15px', boxShadow:1, display:'flex', flexDirection:'column', justifyContent:'center'}}>
                <form onSubmit={handleLogin}>
                  <Box sx={{display:'flex', justifyContent:'center'}}>
                    <Box sx={{width:'85%'}}>
                      <TextField
                        id="userName"
                        variant="outlined"  
                        margin="normal"
                        placeholder="Voer je gebruikersnaam in"
                        value={userName}
                        onChange={(e) => {
                          setUserName(e.target.value);
                          if (credentialsInvalid || accessDenied) {
                            setCredentialsInvalid(false);
                            setAccessDenied(false);
                          }
                        }}
                        inputRef={usernameRef}
                        sx={{
                          mt:'10px',
                          width:'100%',
                          backgroundColor:'white',
                        }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <AccountCircle />
                            </InputAdornment>
                          ),
                          style: {
                            fontSize:'16px',
                            borderRadius:'8px',
                          }
                        }}
                      />
                    </Box>
                  </Box>
                  <Box sx={{display:'flex', justifyContent:'center'}}>
                    <Box sx={{width:'85%'}}>
                      <TextField
                        type={showPassword ? 'text' : 'password'}
                        id="password"
                        variant="outlined"
                        margin="normal"
                        placeholder="Voer je wachtwoord in"
                        value={password}
                        onChange={(e) => {
                          setPassword(e.target.value);
                          if (credentialsInvalid || accessDenied) {
                            setCredentialsInvalid(false);
                            setAccessDenied(false);
                          }
                        }}
                        sx={{
                          mt:'15px',
                          width:'100%',
                          backgroundColor:'white',
                          fontSize:'16px'
                        }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <LockIcon />
                            </InputAdornment>
                          ),
                          endAdornment: (
                            <InputAdornment position="end">
                              {
                                showPassword ? (
                                  <VisibilityIcon 
                                    onClick={() => setShowPassword(false)} 
                                    style={{cursor: 'pointer'}} 
                                  />
                                ) : (
                                    <VisibilityOffIcon 
                                    onClick={() => setShowPassword(true)} 
                                    style={{cursor: 'pointer'}} 
                                  />
                                )
                              }
                            </InputAdornment>
                          ),
                          style: {
                            fontSize:'16px',
                            borderRadius:'8px',
                          }
                        }}
                      />
                    </Box>
                  </Box>
                <Box sx={{display:'flex', justifyContent:'center', mt:1}}>
                  <Box sx={{width:'85%', display:'flex', alignItems:'center', justifyContent:'flex-end'}}>
                    <Typography sx={{color:'#059669', fontWeight:600, cursor:'pointer', userSelect:'none', fontSize:'14px' ,'&:hover': { textDecoration:'underline' }}} onClick={() => window.open("https://infinity.skyspark.nl/user/reset")}>Wachtwoord vergeten?</Typography>
                  </Box>
                </Box>
                  <Box sx={{display:'flex', justifyContent:'center'}}>
                    <Button
                      type="submit"
                      variant="contained"
                      sx={{
                        borderRadius:'8px',
                        mt:'14px',
                        backgroundColor:'#01e987',
                        height:'50px',
                        width:'85%',
                        '&:hover': {
                          backgroundColor: '#059669',
                          color: 'white',
                        }
                      }}>
                        {
                          proccesing ? (<InfLoader size='sm'/>) : (<Typography>Inloggen</Typography>)
                        }
                    </Button>
                  </Box>
                  {credentialsInvalid ? (
                    <Box sx={{height:'20px', mt:'10px'}}>
                      <Typography sx={{fontSize:'14px', fontWeight:'bold'}} color='red' textAlign='center'>
                      De combinatie van gebruikersnaam en wachtwoord is niet geldig
                      </Typography>
                    </Box>
                  ) : accessDenied ? (
                    <Box sx={{height:'20px', mt:'10px'}}>
                      <Typography sx={{fontSize:'14px', fontWeight:'bold'}} color='red' textAlign='center'>
                        Geen toegang tot het dashboard
                      </Typography>
                    </Box>
                  ) : 
                  null}
                </form>
              </Box>
            </Box>
          </Grid>
          <Grid item xl={6} lg={6} md={0} sm={0} xs={0}>
          <Box sx={{width:'100%', height:'100%', backgroundColor:'black', display:'flex', justifyContent:'center', alignItems:'center'}}>
            <Box loading='lazy' sx={{height:'100%', width:'100%',backgroundImage: `url(${backgroundImage})`,backgroundPosition:'center',backgroundRepeat:'no-repeat',backgroundSize:'cover'}}></Box>
          </Box>
          </Grid>
        </Grid>
      ) : (
        <div />
      )}
    </>
  );
}

export default Login;
